export const PLATFORM_ROUTES = {
  ROOT: "/",
  HOME: "/dashboard",
  LOGIN: "/login",
  LOGOUT: "/logout",
  FEATURES: "/features",
  PRICING: "/pricing",
  ECONOMICS: "/economics",
  LEGACY_NOTIFICATION: "/notification",
  LEGACY_HUB_DATA: "/hub-data",
  USER_GUIDE: "/user-guide",
  USER_GUIDE_CONTENT: "/user-guide/guide",
  TECH_SPEC: "/user-guide/tech-spec",
} as const;

export type PlatformRouteKey = keyof typeof PLATFORM_ROUTES;
